import MyPopup from './MyPopup'
import { useUser } from '../UserContext'
import { useEffect, useState } from 'react'
import PulseLoading from './PulseLoading'

// Constants (move to a config file if reused)

const IFRAME_URL =
  'https://app.supademo.com/embed/cm5wb7ia5258e36cgy20km9pq?embed_v=2'

function FirstAppTour() {
  const { showAppTour, setShowAppTour } = useUser()
  const [isLoading, setIsLoading] = useState(true)

  // 🔥 Reset isLoading every time the modal opens
  useEffect(() => {
    if (showAppTour) {
      setIsLoading(true)
    }
  }, [showAppTour])

  const handleClose = () => {
    setShowAppTour(false)
    localStorage.setItem('appTourClosed', 'true')
  }

  return (
    <MyPopup
      isPopupOpen={showAppTour}
      showCloseBtn={true}
      onClose={handleClose}
      popupContent={
        <>
          <div className='iframe-container'>
            {isLoading && (
              <div className='loading-overlay'>
                <p>Loading</p>
                <PulseLoading />
              </div>
            )}

            <iframe
              src={IFRAME_URL}
              loading='lazy'
              title='Panenkafc Demo'
              allow='clipboard-write'
              frameBorder={0}
              webkitallowfullscreen='true'
              mozallowfullscreen='true'
              allowFullScreen
              onLoad={() => setIsLoading(false)}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
            />
          </div>

          <button
            onClick={handleClose}
            className='btn'
            style={{ marginInline: 'auto' }}
          >
            Close
          </button>
        </>
      }
    />
  )
}

export default FirstAppTour
